/**
 *
 * @param {arrayOf(Tag)} tagArray
 * @returns an array of just tagIds. This was made because we often have to grab the tagIds from the tags array in order to use the updateClient endpoint
 */

export const getTagIds = (tagArray) => tagArray.map((tag) => tag.tagId);
